import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import storage from 'local-storage-fallback'
import App from 'modules/App'
import React from 'react'
import ReactDOM from 'react-dom'
import 'regenerator-runtime/runtime'
import 'global.scss'
import * as Sentry from '@sentry/browser'

if (!('localStorage' in window)) {
  global.localStorage = storage
}

console.logXHR = console.error

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/frontend/react-app/sw.js', {
          scope: '/',
        })
        .catch(() => {})
    })
  }

  const sentryRelease =
    process.env.REACT_APP_SENTRY_RELEASE ||
    (typeof global !== 'undefined' && global.SENTRY_RELEASE && global.SENTRY_RELEASE.id) ||
    undefined

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN || '',
    tunnel: '/communication',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.globalHandlersIntegration({
        onerror: true,
        onunhandledrejection: false,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ...(sentryRelease ? { release: sentryRelease } : {}),
  })

  // TODO: add sentry logging maybe?
  console.logXHR = () => {}
}

ReactDOM.render(<App />, document.getElementById('app-root'))
